import {Component, DoCheck, OnInit} from '@angular/core';
import {EditPermissions, NodeBuilder} from "../../../../../../../shared/models";
import {FormControl, FormGroup} from "@angular/forms";
import {ContactReceivingFormNode} from "./contactReceiving";

const NODE_TYPE = 'contactReceiving'

@Component({
  selector: 'app-contact-recieving',
  templateUrl: './contact-recieving.component.html',
  styleUrls: ['./contact-recieving.component.scss']
})
export class ContactRecievingComponent extends NodeBuilder implements OnInit {
  errorBoxStates = {
    default: 0,
    error: 1,
    partial: 2,
    allSelected: 3
  }
  showErrorBox = this.errorBoxStates.default;

  constructor() {
    super(NODE_TYPE)
  }

  checklist = {
    address: false,
    name: false,
    phone: false,
    email: false,
    birthday: false,
    url: false,
    org: false
  };
  contactFields = [];
  menuParams: FormGroup;
  validateFields: FormGroup;
  canEdit: EditPermissions;
  stepUniqueID: string = '';
  isAnyTrue = false;
  isAnyItemTrue;

  ngOnInit(): void {}
  set buildForm(stepData: any) {
    this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
    const formData = ContactReceivingFormNode.toForm(stepData);
    if (!stepData) {
      return;
    }
    this.buildMenuParamsForm(formData);
  }

  get getStepData(): {} {
    const menuParams = this.menuParams.getRawValue();
    const contactReceivingFormNode = new ContactReceivingFormNode(this.nodeType);
    contactReceivingFormNode.addMenuParams(menuParams);
    const nodeData = contactReceivingFormNode.nodeData;
    nodeData['next'] = menuParams.next;
    if(this.stepUniqueID !== '') {
      nodeData['metadata'].stepUniqueID = this.stepUniqueID;
    }
    return nodeData;
  }

  get isNodeValid(): boolean {
    if(!this.isCheckBoxChecked() && this.showErrorBox===this.errorBoxStates.default){
      this.showErrorBox = this.errorBoxStates.error;
    }

    if (this.isCheckBoxChecked()) {
      this.menuParams.markAllAsTouched();
      return this.menuParams.valid;
    } else {
      if(this.showErrorBox===this.errorBoxStates.error) {
        this.menuParams.markAllAsTouched();
        return false;
      }
      this.menuParams.markAllAsTouched();
      return this.menuParams.valid;
     }
  }

  buildMenuParamsForm(formData) {
    this.menuParams = ContactReceivingFormNode.getMenuTemplate(this.canEdit);
    this.menuParams.patchValue(formData.menuParams);
  }

  selectAll() {
    const selectAll = document.getElementById('select-all-checkbox') as HTMLInputElement;
    const container = selectAll.closest('.checkbox-container') as HTMLElement;
    const checked = selectAll.checked;
    for (let item in this.checklist) {
      this.checklist[item] = checked;
      this.menuParams.controls['validateFields'].get(item).patchValue(checked);
    }
    this.isAnyTrue = checked;
    this.showErrorBox = this.isAnyTrue ? this.errorBoxStates.allSelected : this.errorBoxStates.default;
    selectAll.classList.remove('partial');
    if (!this.isAnyTrue) {
      container.style.borderColor = '#D4D9E2';
      container.style.backgroundColor = 'white';
    }
    this.checkBoxChecked();
  }

  checkBoxChecked() {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox: HTMLInputElement) => {
      const all = checkbox.closest('.checkbox-container') as HTMLElement
      if (checkbox.checked) {
        all.style.backgroundColor = '#F5FBFD';
        all.style.borderColor = '#95E1F5';
      } else {
        all.style.borderColor = '#D4D9E2';
        all.style.backgroundColor = 'white';
      }
    });
  }

  partiallySelected(event: any) {
    const allIcon = document.getElementById('select-all-checkbox') as HTMLInputElement;
    const all = document.querySelector('.checkbox-container') as HTMLElement;
    const box = event.target as HTMLInputElement;
    let boxID = box.id;
    if (boxID ==='fname') boxID = 'name';

    if (box.checked){
      this.menuParams.controls['validateFields'].get(boxID).patchValue(true);
      this.checklist[boxID] = true;
      allIcon.checked;
      this.isAnyTrue = true;
    }else {
      this.menuParams.controls['validateFields'].get(boxID).patchValue(false);
      this.checklist[boxID] = false;
      for (let item in this.checklist) {
        this.isAnyTrue = !!this.checklist[item];
      }
    }

    if (this.isAnyTrue) {
      allIcon.classList.add('partial')
      allIcon.checked = true;
      all.style.backgroundColor = '#F5FBFD';
      all.style.borderColor = '#95E1F5';
      this.showErrorBox = this.errorBoxStates.partial;
    } else {
      all.style.borderColor = '#D4D9E2';
      all.style.backgroundColor = 'white';
      allIcon.checked = false;
      allIcon.classList.remove('partial');
    }
  }
  isCheckBoxChecked(): boolean {
    const FormControls = [
      this.menuParams.get('validateFields').get('address') as FormControl,
      this.menuParams.get('validateFields').get('name') as FormControl,
      this.menuParams.get('validateFields').get('email') as FormControl,
      this.menuParams.get('validateFields').get('phone') as FormControl,
      this.menuParams.get('validateFields').get('url') as FormControl,
      this.menuParams.get('validateFields').get('birthday') as FormControl,
      this.menuParams.get('validateFields').get('org') as FormControl,
    ];

    return FormControls.every((formControl) => formControl.value===true);
  }

  changeColor(event: any = null) {
    const checkbox = event.target as HTMLInputElement;
    const container = checkbox.closest('.checkbox-container') as HTMLElement;
    if (checkbox.checked) {
      container.style.backgroundColor = '#F5FBFD';
      container.style.borderColor = '#95E1F5';
    } else {
      container.style.borderColor = '#D4D9E2';
      container.style.backgroundColor = 'white';
    }
  }

  protected readonly Object = Object;
}
